import { render, staticRenderFns } from "./TableSkeleton.vue?vue&type=template&id=48596126&"
import script from "./TableSkeleton.vue?vue&type=script&lang=js&"
export * from "./TableSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports